import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import CheckIcon from '@material-ui/icons/Check'
import { withStyles } from '@material-ui/core/styles'

import Button from './Button'


const styles = {
  button: {
    height: 56,
    marginLeft: -1,
    borderRadius: '0 3px 3px 0',
    background: 'rgba(0, 0, 0, 0.12)',
    border: '1px solid rgba(0, 0, 0, 0.23)',
  },
  textField: {
    width: 'calc(100% - 63px)',
    '& fieldset': {
      borderRadius: '3px 0 0 3px',
    },
  },
}


const TagField = ({
  value,
  classes,
  onClick,
  className,
  fullWidth,
  isLoading,
  fieldClassName,
  ...props
}) => {
  const handleKeyPress = e => e.key === 'Enter' && onClick && onClick()

  return (
    <div className={className}>
      <TextField
        value={value}
        variant="outlined"
        disabled={isLoading}
        onKeyPress={handleKeyPress}
        className={classNames(classes.textField, {
          [classes.fullWidth]: fullWidth,
        }, fieldClassName)}
        {...props}
      />
      <Button className={classes.button} onClick={onClick}><CheckIcon /></Button>
    </div>
  )
}


TagField.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  fieldClassName: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(TagField)
